import React, { useState, useEffect } from 'react';
import { Button, Input, DatePicker, Switch } from 'antd';
import dayjs from 'dayjs';
import { toastSuccess, toastError, toastWarn } from '../Toast/ToastComponent';
import SurveyApi from '../../Api/SurveyPeriodApi';

const AddSurveyPeriod = ({ modaldata, setModal, reload, mode = 'add' }) => {
  const isEdit = mode === 'edit';
  const isView = mode === 'view';
  const [form, setForm] = useState({
    period_name: '',
    fromMonth: null,
    toMonth: null,
    activeStatus: true,
  });
  useEffect(() => {
    if (modaldata?.id) {
      setForm({
        period_name: modaldata.period_name || '',
        fromMonth: modaldata.fromMonth
          ? dayjs(modaldata.fromMonth, 'DD-MMMM-YYYY')
          : null,
        toMonth: modaldata.toMonth
          ? dayjs(modaldata.toMonth, 'DD-MMMM-YYYY')
          : null,
        activeStatus:
          modaldata.activeStatus !== undefined
            ? modaldata.activeStatus === true ||
              modaldata.activeStatus === 'true'
            : true,
      });
    } else {
      setForm({
        period_name: '',
        fromMonth: null,
        toMonth: null,
        activeStatus: true,
      });
    }
  }, [modaldata]);
  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });
  const handleDateChange = (date, field) => setForm({ ...form, [field]: date });
  const handleToggle = (checked) => setForm({ ...form, activeStatus: checked });
  const handleSave = async () => {
    if (isView) return;

    if (!form.period_name) return toastWarn('Period name is required');
    if (!form.fromMonth || !form.toMonth)
      return toastWarn('Please select both dates');
    if (form.fromMonth.isAfter(form.toMonth))
      return toastWarn('From date cannot be greater than To date');

    const payload = {
      period_name: form.period_name.trim(),
      fromMonth: form.fromMonth.format('DD-MMMM-YYYY'),
      toMonth: form.toMonth.format('DD-MMMM-YYYY'),
    };
    try {
      let res;
      if (isEdit) {
        res = await SurveyApi.update({ id: modaldata.id, ...payload });
      } else {
        res = await SurveyApi.create(payload);
      }

      if (res?.data?.success) {
        toastSuccess(res.data.message || 'Saved successfully');
        reload();
        setModal(false);
      } else {
        toastError(res?.data?.message || 'Failed');
      }
    } catch (err) {
      toastError(err?.message || 'Something went wrong');
    }
  };
  return (
    <>
      <Input
        name="period_name"
        placeholder="Period Name"
        value={form.period_name}
        onChange={handleChange}
        className="mb-2"
        disabled={isView}
      />
      <DatePicker
        placeholder="From Date"
        value={form.fromMonth}
        onChange={(date) => handleDateChange(date, 'fromMonth')}
        format="DD-MM-YYYY"
        className="mb-2 w-100"
        disabled={isView}
        placement="bottomLeft"
        getPopupContainer={(trigger) => trigger.parentElement}
        disabledDate={(current) =>
          form.toMonth ? current && current.isAfter(form.toMonth, 'day') : false
        }
      />

      <DatePicker
        placeholder="To Date"
        value={form.toMonth}
        onChange={(date) => handleDateChange(date, 'toMonth')}
        format="DD-MM-YYYY"
        className="mb-3 w-100"
        disabled={isView}
        placement="topLeft"
        getPopupContainer={(trigger) => trigger.parentElement}
        disabledDate={(current) =>
          form.fromMonth
            ? current && current.isBefore(form.fromMonth, 'day')
            : false
        }
      />
      <div className="mb-3">
        <span className="me-2">Active:</span>
        <Switch
          checked={form.activeStatus}
          onChange={handleToggle}
          disabled={isView}
        />
      </div>
      <div className="d-flex justify-content-center">
        <Button onClick={() => setModal(false)}>
          {isView ? 'Close' : 'Cancel'}
        </Button>
        {!isView && (
          <Button type="primary" onClick={handleSave} className="ms-2">
            {isEdit ? 'Update' : 'Save'}
          </Button>
        )}
      </div>
    </>
  );
};
export default AddSurveyPeriod;
